import { IssueOrder, PaginationOrder, TaskOrder } from "@/graphql";

export const lisa3EventOrderingOptions = [
  IssueOrder.ASC,
  IssueOrder.DESC,
  IssueOrder.OCCURRENCE_ASC,
  IssueOrder.OCCURRENCE_DESC,
];

export const lisa3ActionOrderingOptions = [
  TaskOrder.ASC,
  TaskOrder.DESC,
  TaskOrder.DEADLINE,
  TaskOrder.DEADLINE_DESC,
];

export function eventPageOrder(ordering: IssueOrder) {
  const occurrence =
    ordering === IssueOrder.OCCURRENCE_ASC || ordering === IssueOrder.OCCURRENCE_DESC;
  return {
    orderBy: occurrence ? "occurrenceDate" : "createdAt",
    order:
      ordering === IssueOrder.ASC || ordering === IssueOrder.OCCURRENCE_ASC
        ? PaginationOrder.ASC
        : PaginationOrder.DESC,
  };
}

export function eventPageCursor(
  event: { id: number; createdAt: string; occurrenceDate: string },
  ordering: IssueOrder,
) {
  const value =
    ordering === IssueOrder.OCCURRENCE_ASC || ordering === IssueOrder.OCCURRENCE_DESC
      ? event.occurrenceDate
      : event.createdAt;
  return JSON.stringify({ value, id: event.id });
}

export function compareLISA3Actions(
  left: { id: number; createdAt: string; deadline?: string | null },
  right: { id: number; createdAt: string; deadline?: string | null },
  ordering: TaskOrder,
) {
  if (ordering === TaskOrder.DEADLINE || ordering === TaskOrder.DEADLINE_DESC) {
    const leftDeadline = left.deadline == null ? null : Date.parse(left.deadline);
    const rightDeadline = right.deadline == null ? null : Date.parse(right.deadline);
    if (leftDeadline == null) return rightDeadline == null ? right.id - left.id : 1;
    if (rightDeadline == null) return -1;
    const difference = leftDeadline - rightDeadline;
    return (ordering === TaskOrder.DEADLINE ? difference : -difference) || right.id - left.id;
  }

  const difference = Date.parse(left.createdAt) - Date.parse(right.createdAt);
  return (ordering === TaskOrder.ASC ? difference : -difference) || right.id - left.id;
}
